import _extends from "@babel/runtime/helpers/esm/extends";
import { Box, Modal } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import Button from "../../../atoms/Button";
import Typography from "../../../atoms/Typography";
import colors from "../../../theme/colors";
import { disableScrollBody } from "../../../utils/disableScrollBody";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ModalNotiNotEnough(props) {
  const {
    open = false,
    onClose,
    title,
    description,
    buttonProps,
    titleOut,
    descriptionOut,
    total,
    isLoadPage
  } = props;
  const refContent = useRef();
  useEffect(() => {
    if (typeof window !== "undefined") {
      disableScrollBody(open);
    }
  }, [open]);
  const handleCloseModal = () => {
    if (isLoadPage) {
      if (window) {
        window.location.href = `${window.location.href}`;
      }
      return;
    }
    onClose?.();
  };
  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "auto"
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      },
      onClick: handleCloseModal,
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: {
            xs: "90%",
            md: "60%",
            xl: "49%"
          },
          padding: "24px 28px",
          maxWidth: {
            xs: "311px",
            md: "547px"
          },
          maxHeight: "642px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative"
        },
        ref: refContent,
        onClick: e => {
          e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            marginTop: "40px",
            width: "100%",
            textAlign: "center",
            color: colors.primary.bandaiNamcoBlack
          },
          variant: "h4"
          //@ts-ignore
          ,
          dangerouslySetInnerHTML: {
            __html: total === 0 || total === "0" ? titleOut : title
          }
        }), /*#__PURE__*/_jsx(Typography, {
          sx: {
            marginTop: {
              xs: "16px",
              md: "12px"
            },
            textAlign: "center",
            color: colors.neutral.neutral2
          },
          variant: "p6"
          //@ts-ignore
          ,
          dangerouslySetInnerHTML: {
            __html: total === 0 || total === "0" ? descriptionOut : description
          }
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            maxWidth: {
              xs: "100%",
              md: "271px"
            },
            width: "100%",
            display: "flex",
            "& button": {
              width: "100%"
            }
          },
          children: /*#__PURE__*/_jsx(Button, _extends({
            sx: {
              margin: {
                xs: "24px 0px",
                md: "40px 0px"
              }
            }
          }, buttonProps, {
            onClick: handleCloseModal
          }))
        })]
      })
    })
  });
}